import React, { useEffect, useRef, useState } from 'react';

const ImageLoader = props => {
  const {url, onImgClick, className} = props;
  const [showImage, setShowImage] = useState(false);
  const backgroundImg = useRef(null);

  useEffect(() => {
    if (!url) return;
    const image = new Image();
    image.src = url;
    image.onload = () => {
      try {
        if(backgroundImg.current)
        {
          backgroundImg.current.src = image.src;
          backgroundImg.current.backgroundImage = image.src;  
          setShowImage(true)
        }
      } catch (error) {
        console.error(error);
      }
    };
  }, [url]);
  
  const handleImgClick=()=>{
    if(onImgClick) onImgClick();
  }
  return (
    <>
    {
      <img
      style={{display: showImage ? "block":'none'}}
      className={className}
      onClick={handleImgClick}
      alt="background"
      ref={backgroundImg}
    />
    }
    </>
   
  );
};

ImageLoader.propTypes = {
  
};

export default ImageLoader;